const getRandomScore = (par) => {
    let min = par - 2
    let max = par + 3
    return Math.floor(Math.random() * (max-min) + min)
}

export default getRandomScore